import React, { useMemo } from 'react';
import { useEvent } from '../../pages/events/event/EventProvider';
import './Progressbar.scss';
import TaskCard from './TaskCard';
import { useWindowSize } from 'usehooks-ts';

const ProgressBar = ({ progress, numCards, streak }) => {
  const {width} = useWindowSize()
  const BAR_HEIGHT =width>800 ? numCards*20 : numCards*40;
  const [{ event }] = useEvent();
  const tasks = useMemo(() => {
    if (!event?.events?.length) return [];

    return event.events;
  }, [event?.events]);

  return (
    <>
      <div className='progress-bar-container' style={{ height: `${BAR_HEIGHT}rem` }}>
        <h3 className='top_days'>0 DAYS</h3>
        <div className='progress-bar'>
          <div className='progress-fill' style={{ height: `${progress}%` }}>
            <div className='progress_pointer'>{streak || 0}</div>
          </div>
        </div>

        {/* Milestone Markers */}
        {Array.from({ length: numCards }, (_, i) => (
          <div className='milestone' key={i} style={{ top: `${(i / numCards) * 100}%` }}>
            <div className='icon'>
              <img src='https://dskhnex0aho1n.cloudfront.net/public/cs-tiger.png' />
            </div>
          </div>
        ))}
        <div className='milestone' style={{ top: `100%` }}>
          <div className='icon'>
            <img src='https://dskhnex0aho1n.cloudfront.net/public/cs-tiger.png' />
          </div>
        </div>
        {tasks.map((task, i) => (
          <TaskCard className={i % 2 === 0 ? 'left' : 'right'} top={`${(i / numCards) * 100}%`} task={task} index={i}  />
        ))}
        <h3 className='bottom_days'>30 DAYS</h3>
      </div>
    </>
  );
};

export default ProgressBar;
